function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.1 0.143)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.976 6.931)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M58.844,123.571a.581.581,0,0,0-.788-.211h0l-4.43,2.557a.556.556,0,0,0-.095-.143l-4.064-4.064a.581.581,0,0,0-.793-.027l-4.645,4.064a.581.581,0,0,0,.759.878l0,0,4.238-3.707,3.586,3.586L42.09,132.578v-9.3h.078a1.753,1.753,0,0,0,0-3.5H42.09v-1.723a.581.581,0,0,0-1.161,0v1.723h-2.3L35.7,116.621v-.307a.581.581,0,0,0-.581-.581H31.64a.581.581,0,0,0-.581.581v6.952a17.306,17.306,0,0,1-3.48,10.384.6.6,0,0,0-.041.062,2.349,2.349,0,0,0,.85,3.189,2.3,2.3,0,0,0,1.161.314,2.323,2.323,0,0,0,.6-.08,2.27,2.27,0,0,0,1.389-1.051l.948-1.382a18.284,18.284,0,0,0,2.6-5.7l1.2.6v1.806a1.742,1.742,0,0,0,3.484,0v-3.92a.581.581,0,0,0-.29-.5L35.686,124.8c0-.165.019-.33.019-.5v-3.052l1.7,1.839a.58.58,0,0,0,.426.186h3.1v9.842a.545.545,0,0,0,.023.111L29.9,139.616a.581.581,0,0,0,.574,1.009l.007,0,28.159-16.256A.581.581,0,0,0,58.844,123.571ZM31.529,134.047l-.974,1.421a1.152,1.152,0,0,1-1.569.438l-.014-.008a1.184,1.184,0,0,1-.442-1.579,18.474,18.474,0,0,0,3.642-9.876h2.365A17.138,17.138,0,0,1,31.529,134.047Zm3.014-10.765H32.22V116.9h2.322Zm4.064,4.544v3.584a.581.581,0,0,1-1.161,0v-2.164a.581.581,0,0,0-.319-.518l-1.771-.894c.111-.573.2-1.152.254-1.737Zm-.523-5.708-2.38-2.571v-1.219l2.245,2.424a.58.58,0,0,0,.426.186h2.949a.483.483,0,0,0,.372,0h.473a.6.6,0,0,1,0,1.18Z",
  transform: "translate(-27.229 -115.734)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.81)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M87.016,22.542H85.8a2.922,2.922,0,1,0,0,1.161h1.219a.581.581,0,1,0,0-1.161Zm-4.064,2.341a1.742,1.742,0,0,1-1.637-1.18h3.273A1.742,1.742,0,0,1,82.952,24.883Zm-1.637-2.341a1.725,1.725,0,0,1,3.273,0Z",
  transform: "translate(-80.053 -20.238)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.028)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.322,75.734A2.322,2.322,0,0,0,0,78.056v5.225a4.069,4.069,0,0,0,4.064,4.064.581.581,0,0,0,.581-.581V78.056A2.322,2.322,0,0,0,2.322,75.734ZM3.484,86.127a2.908,2.908,0,0,1-2.322-2.845V78.056a1.161,1.161,0,0,1,2.322,0Z",
  transform: "translate(0 -75.734)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.707 8.672)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M370.322,139.734a2.322,2.322,0,1,0,2.322,2.322A2.322,2.322,0,0,0,370.322,139.734Zm0,3.484a1.161,1.161,0,1,1,1.161-1.161A1.161,1.161,0,0,1,370.322,143.218Z",
  transform: "translate(-368 -139.734)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.542 5.637)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M422.317,97.992l0,0a.581.581,0,0,0-.8.2h0l-.6,1.008a.581.581,0,0,0,1,.592l.6-1.006A.581.581,0,0,0,422.317,97.992Z",
  transform: "translate(-420.841 -97.909)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(32.032 7.701)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M443.477,126.641a.581.581,0,0,0-.773-.217l-1.034.581a.581.581,0,0,0-.223.79h0a.581.581,0,0,0,.79.222l1.033-.581A.581.581,0,0,0,443.477,126.641Z",
  transform: "translate(-441.374 -126.356)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(32.481 10.414)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M449.334,163.734h-1.193a.581.581,0,0,0,0,1.161h1.193a.581.581,0,1,0,0-1.161Z",
  transform: "translate(-447.56 -163.734)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.192 10.414)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M321.334,163.734h-1.193a.581.581,0,0,0,0,1.161h1.193a.581.581,0,1,0,0-1.161Z",
  transform: "translate(-319.56 -163.734)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.804 7.553)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M329.9,124.962l-1.033-.581a.581.581,0,0,0-.569,1.013l1.033.581a.581.581,0,1,0,.569-1.013Z",
  transform: "translate(-327.997 -124.307)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.769 5.637)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M356.751,99.206l-.6-1.008a.581.581,0,1,0-1,.592l.6,1.006a.581.581,0,0,0,1-.589Z",
  transform: "translate(-355.075 -97.913)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.454 4.937)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M392.653,88.27a.581.581,0,0,0-.581.581v1.161a.581.581,0,0,0,1.161,0V88.851A.581.581,0,0,0,392.653,88.27Z",
  transform: "translate(-392.072 -88.27)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.2
}))));

var SvgHiking = function SvgHiking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 35.035,
    height: 32.142,
    viewBox: "0 0 35.035 32.142",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHiking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hiking.89e38c08.svg";
export { ForwardRef as ReactComponent };